import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Howl, Howler } from "howler"
import { AppstorageTsService } from '../appstorage/appstorage.ts.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})

export class AudioService {

  public isAudioOn: boolean = true;
  public isInGame: boolean = false;
  public isAppActive: boolean = true;

  protected allSounds: Howl[];
  protected currentMusic: Howl;

  protected masterVolume: number = 1;
  protected musicVolume: number = 0.165; // 0.25

  constructor(
    private configService: ConfigService,
    public appStorageService: AppstorageTsService,
    protected platform: Platform
  ) {

    this.allSounds = [];

    this.appStorageService.getAudioOn().then((audioOn) => {
      console.info("audioOn: ", audioOn)

      this.isAudioOn = audioOn.value == null || audioOn.value == "true" ? true : false;
    });
  }

  loadAudio() {
    Howler.html5PoolSize = 0;

    this.allSounds = [];

    const audioURL = this.configService?.getConfig()?.CDN_BASEURL;

    let sounds = [
      { name: "BGMusic", url: "/assets/audio/SD_social_MainLobby_LOOP.mp3" },
      { name: "RocketWheelSpinning", url: "/assets/audio/wheelSpinning.mp3" },
    ]

    const audio = this.configService.getConfig()?.APP_AUDIO;
    const masterVolume = this.configService.getConfig()?.APP_AUDIO_MASTER_VOLUME;
    const musicVolume = this.configService.getConfig()?.APP_AUDIO_MUSIC_VOLUME;

    if (masterVolume != null)
      this.masterVolume = masterVolume;

    if (musicVolume != null)
      this.musicVolume = musicVolume;

    if (audio != null && audio != "") {
      sounds = JSON.parse(audio)
    }
    else {
      console.log("config APP_AUDIO is missing... falling back to defaults");
    }

    for (let i: number = 0; i < sounds.length; i++) {
      let pathParts = sounds[i].url.split(".");
      let pathSound = pathParts[0].slice();
      let pathM4A = pathParts[1].indexOf("m4a") != -1 ? audioURL + pathSound + ".m4a" : null;
      let pathOGG = pathParts[1].indexOf("ogg") != -1 ? audioURL + pathSound + ".ogg" : null;
      let pathMP3 = pathParts[1].indexOf("mp3") != -1 ? audioURL + pathSound + ".mp3" : null;

      let extensions = [];
      if (pathM4A != null)
        extensions.push(pathM4A);

      if (pathOGG != null)
        extensions.push(pathOGG);

      if (pathMP3 != null)
        extensions.push(pathMP3);

      let sound: Howl;
      let iOS = this.platform.is("capacitor") && this.platform.is("ios")
      if (sounds[i].name != "BGMusic" || !iOS) {
        sound = new Howl({
          src: extensions
        });
      }
      else {
        // fix SDSC-386 - lobby music plays once aloud then once silent and repeats (only on iOS of course)
        // solution adapted from https://github.com/goldfire/howler.js/issues/1586#issuecomment-1479093930
        sound = new Howl({
          src: extensions,
          autoplay: false,
          loop: false,
          html5: true,
          onplay: () => {
            //@ts-ignore
            sound._sounds[0]._node.addEventListener('timeupdate',
              function () {
                let buffer = 0.30;
                if (this.currentTime > this.duration - buffer) {
                  this.currentTime = 0;
                }
              },
              false
            );
          },
        });
      }

      this.allSounds[sounds[i].name] = sound;

      sound.once('load', () => {
        if (sounds[i].name == "BGMusic") {
          this.playMusic("BGMusic");
        }
      })

      // sound.once('loaderror', () => {
      //   console.log("sound loaderror", sounds[i].name)
      //   Howler.unload();
      // });

      // sound.once('playerror', () => {
      //   console.log("sound playerror", sounds[i].name)
      //   Howler.unload();
      // });

      // sound.once('stop', () => {
      //   console.log("sound stop", sounds[i].name)
      // });

      // sound.once('unlock', () => {
      //   console.log("sound unlock", sounds[i].name)
      // });

      // sound.once("end", () => {
      //   console.log("sound end", sounds[i].name)
      // })
    }
  }

  playSound(name: string, volume: number = 1) {
    if (this.isAudioOn && this.isAppActive) {
      const sound: Howl = this.allSounds[name];
      if (sound != null) {
        sound.stop();
        sound.volume(this.masterVolume * volume);
        sound.play();
      }
    }
  }

  fadeSound(name: string, from: number, to: number, ms: number = 1000) {
    if (this.isAudioOn && this.isAppActive) {
      const sound: Howl = this.allSounds[name];
      if (sound != null) {
        sound.fade(this.masterVolume * from, this.masterVolume * to, ms);
      }
    }
  }

  playMusic(name: string, loop: boolean = true) {

    if (!this.isAudioOn || this.isInGame || !this.isAppActive) {
      console.log(`cant play music... isAudioOn: ${this.isAudioOn} isInGame: ${this.isInGame} isAppActive: ${this.isAppActive}`);
      return;
    }

    const musicOld = this.currentMusic;
    const musicNew: Howl = this.allSounds[name];

    if (musicNew == musicOld) {
      console.log("music already playing...");
      return;
    }

    if (musicOld != null) {
      musicOld.fade(musicOld.volume(), 0, 500);
      musicOld.once("fade", () => {
        musicOld.stop();
      });
    }

    if (musicNew != null) {
      let iOS = this.platform.is("capacitor") && this.platform.is("ios")
      musicNew.volume(0);
      musicNew.loop(!iOS);
      musicNew.play();
      musicNew.fade(0, this.musicVolume, 1000);

      this.currentMusic = musicNew;
    }
  }

  stopMusic() {
    console.log("stopMusic");
    const sound: Howl = this.allSounds["BGMusic"];
    if (sound != null) {
      sound.stop();
    }

    this.currentMusic = null;
  }

  fadeMusic(volume: number, time: number = 1000) {
    console.log("fadeMusic", volume, time);
    if (this.currentMusic != null) {
      this.currentMusic?.fade(this.currentMusic.volume(), volume * this.musicVolume, time);
    }
  }
}
